import { useSelector } from 'react-redux';
import {SpinnerDotted} from 'spinners-react';
import empty from '../Assets/empty.jpg'
const Loader = ()=>{
    const loading = useSelector(state=>state.LoadingReducer)
    return <div className="flex flex-row justify-center items-center  w-[100vw] min-h-screen">
        {
            (loading)?
            <SpinnerDotted size={76} thickness={180} speed={100} color="#36ad47" />
            :
            <div className='flex flex-row items-center justify-center min-w-[100vw]  min-h-screen dark:bg-secondary-dark lg:px-8 md:px-4 px-2'>
                <img alt='empty results' src={empty} className=' object-cover lg:max-w-[60vw]'/>
            </div>
        }
    </div>
}

export default Loader